"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _asyncComponent = require("./asyncComponent");

var _asyncComponent2 = _interopRequireDefault(_asyncComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HearingSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/HearingSearch").then(function (module) {
    return module.default;
  });
});
var HearingEntry = (0, _asyncComponent2.default)(function () {
  return import("../Screens/HearingEntry").then(function (module) {
    return module.default;
  });
});

var routes = [{
  path: "common-hearing/hearing-search",
  component: HearingSearch,
  needsAuthentication: true
}, {
  path: "common-hearing/hearing-entry-form",
  component: HearingEntry,
  needsAuthentication: true
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ../lib/commonhearing-citizen/Routes/commonhearing-routes.js
// module id = 3516
// module chunks = 1137